import React, { useState, useEffect, useRef } from "react";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import { OSSIcon, useOnClickOutside } from "@oss/components";

/**
 * Input with an onBlur method that will fire an update request
 * @param {string} value - what is displayed when not editing, and what is in the input otherwise
 * @param {func} onBlur - an object with a {[objectKey]: newValue} needs to be passed back through onBlur to update the corresponding object
 * @param {string} objectKey - value that will map to whatever
 */
const OSSEditableTypography = ({
  value = "",
  onBlur = () => {},
  objectKey = ""
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editingText, setEditingText] = useState(value);

  const handleChange = evt => {
    setEditingText(evt.target.value);
  };

  const handleBlur = () => {
    onBlur({ [objectKey]: editingText });
    setIsEditing(false);
  };

  useEffect(() => {
    if (isEditing) {
      setEditingText(value);
    }
  }, [isEditing, setEditingText, value]);

  // This will either run on blur or on click outside of element
  const textFieldRef = useRef();
  useOnClickOutside(textFieldRef, handleBlur);

  return isEditing ? (
    <TextField
      ref={textFieldRef}
      onChange={handleChange}
      onBlur={handleBlur}
      value={editingText}
      variant="outlined"
      size="small"
      fullWidth
      style={{
        background: "white"
      }}
    />
  ) : (
    <Typography variant="body2">
      {value}
      <OSSIcon name="edit" size="small" onClick={() => setIsEditing(true)} />
    </Typography>
  );
};

export default OSSEditableTypography;
